import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Bolt({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 12 12"
    >
      <Path
        d="M3 8.00085L6 0V5.00085H9L6 11.9998V8.00085H3Z"
        fill={iconColor}
      />
    </Svg>
  );
}
